import type { QuizGroupItem } from '@/types/quizSet'

export const QUIZ_GROUP_PREVIEW_TYPES = ['Q', 'S', 'QQS'] as const

export type QuizGroupPreviewType = typeof QUIZ_GROUP_PREVIEW_TYPES[number]

export interface QuizGroupPreviewBuckets {
  Q: QuizGroupItem[]
  S: QuizGroupItem[]
  QQS: QuizGroupItem[]
  other: QuizGroupItem[]
}

export function groupQuizItemsForPreview(items: QuizGroupItem[]): QuizGroupPreviewBuckets {
  const buckets: QuizGroupPreviewBuckets = { Q: [], S: [], QQS: [], other: [] }

  for (const item of items) {
    const type = item.type.trim().toUpperCase()
    if (type === 'Q' || type === 'S' || type === 'QQS') buckets[type].push(item)
    else buckets.other.push(item)
  }

  return buckets
}
